let fallbackSessionId = '';

export function newFormOperationId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID().replace(/-/g, '');
  if (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function') {
    return Array.from(crypto.getRandomValues(new Uint8Array(16)), b => b.toString(16).padStart(2, '0')).join('');
  }
  return '';
}

export function getSessionId(): string {
  try {
    const previous = localStorage.getItem('sw_sid');
    if (previous && /^[A-Za-z0-9_-]{1,64}$/.test(previous)) return previous;
    const id = typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function' ? crypto.randomUUID() : newFormOperationId();
    if (id) { localStorage.setItem('sw_sid', id); return id; }
  } catch { /* Storage can be unavailable; use the same in-memory session for this page. */ }
  if (!fallbackSessionId) fallbackSessionId = newFormOperationId() || `${Date.now().toString(16)}-${Math.random().toString(16).slice(2, 10)}`;
  return fallbackSessionId;
}
